export const theme = {
  light: {
    danger: '#e02c2c',
    info: '#0db151',
    confirm: '#375fd8',
    lightGrey: '#ccc',
    background: '#fff',
    fontColor: '#222',
    fontColorWhite: '#eee',
    fontColorGrey: '#777',
  },
}